export enum PrintLocation {
  APP1 = 'app1',
  APP2 = 'app2',
}

export const PrintLocationLabels: Record<PrintLocation, string> = {
  [PrintLocation.APP1]: 'APP1',
  [PrintLocation.APP2]: 'APP2',
};

export const PrintLocationOptions = Object.entries(PrintLocationLabels).map(
  ([value, label]) => ({
    value: value as PrintLocation,
    label,
  })
);
